import { render, staticRenderFns } from "./LtvPaid.vue?vue&type=template&id=37e0cd38&scoped=true&"
import script from "./LtvPaid.vue?vue&type=script&lang=js&"
export * from "./LtvPaid.vue?vue&type=script&lang=js&"
import style0 from "./LtvPaid.vue?vue&type=style&index=0&id=37e0cd38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0cd38",
  null
  
)

export default component.exports